import { createGlobalStyle } from 'styled-components';

const backgroundColor = '#FFF';
const primaryColor = '#efefef';
const secondaryColor = 'rgb(33 133 208)';
const neonGreen = '#7eb10f';

import { DEUCE } from './components/common/theme/ThemeController';

/* eslint no-unused-expressions: 0 */
export default createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }
  @media print {
    body{
      padding: 40px !important;
    }
    .noprint {
      display:none !important;
    }
  } 
  
  .pdfNoPrint{
    display:none !important;
  }
  body {
    font-family: Inter,sans-serif;;
  }
  body.fontLoaded {
    font-family: Inter,sans-serif;;
  }

  .pg-viewer-wrapper {
    overflow-y: auto !important;
  }

  html {
    word-break: initial;
  }

  .workflowFormEditor {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

  @keyframes entrance-animation {
    from {
        opacity: 0.0;
        transform: translate3d(0px, -10px, 0px);
    }

    to {
        opacity: 1.0;
        transform: translate3d(0px, 0px, 0px);
    }
}

  #app {
    background-color: var(--background-color) !important;
    min-height: 100%;
    min-width: 100%;
    height:100%;
    width: 100%;
  }
  #docketSidebar{
    overflow-y:visible !important
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

  p,
  label {
    font-family: Inter,sans-serif;;
    line-height: 1.5em;
  }

  th {
    // padding: .25em !important;
  }
  
  .leaflet-control-layers, .leaflet-control-attribution {
    visibility: hidden !important;
    }

  .react-datepicker__input-container {
    width: 100% !important;
  }

  .react-datepicker-wrapper {
    width: 100% !important;
  }

  .react-datepicker__time-container {
    width: 90px !important;
  }

  .react-datepicker__time {
    width: 90px !important;
  }

  .react-datepicker__time-list {
    width: 90px !important;
  }

  .react-datepicker__time-box {
    width: 90px !important;
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    margin-right: 25px !important;
  }

  .ui.input.icon {
    width: 100% !important;
  }
  .mainActionButton{
    border: 1px solid #fff !important;
    background-color: ${neonGreen} !important;
    box-shadow: 0 3px 2px rgba(0,0,0,.514) !important;
    transition: .2s !important;
    position: fixed !important;
    bottom: 1em !important;
    z-index: 401 !important;
    right: 1em !important;
    padding: 1em !important;
    font-size: 25px !important; 
    color:white;
  }
  .mainActionButton i{
    color:white;
  }

  .actionButtonMobile {
    align-self: center !important;
    margin-right: .25em !important;
    font-size: 12px;
    font-family: Inter !important;
  }

  * {
    box-sizing: border-box;
  }

  .activeEntity {
    color: #2185d0 !important;
    border-bottom: 1px solid #2185d0 !important;
  }

  .inactiveEntity {
    color: #999  !important;
    border-bottom: 1px solid #999 !important;
  }

  .negativeEntity {
    color: #db2828 !important;
    border-bottom: 1px solid #db2828 !important;
  }

  .docketFormHeader {
    display: flex !important;
    justify-content: space-between !important;
    cursor: pointer !important;
  }

  .docketFormContent {
    margin-left: 2em;
    margin-bottom: 3em;
  }

  .inactiveMenuItem {
    border: 2px solid #FFF !important;
  }

  .inactiveMenuItem:hover {
    background-color: #cacacaba !important;
    box-shadow: inset 0px 0px 5px rgba(255,255,255,0.9) !important;
  }

  .activeMenuItem {
    border: 2px solid #FFF !important;
  }

  .ui.form .field > label {
    display: block;
    margin: 0em 0em 0.28571429rem 0em;
    color: rgba(0, 0, 0, 0.87);
    font-size: 1.05em;
    font-weight: 700;
    text-transform: none;
    font-family: Inter;
    margin-top: 1.2em;
  }

  .ui.checkbox .box, .ui.checkbox label {
    cursor: auto;
    position: relative;
    display: block;
    padding-left: 1.85714em;
    outline: none;
    font-size: 1em;
    font-weight: 500;
    font-family: Inter;
}

  // input,
  // .StripeElement {
  //   display: block;
  //   margin: 10px 0 20px 0;
  //   padding: 10px 14px;
  //   font-size: 1em;
  //   font-family: 'Inter' !important;
  //   box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  //   border: 0;
  //   outline: 0;
  //   border-radius: 4px;
  //   background: white;
  // }

  // input::placeholder {
  //   color: #aab7c4;
  // }

  // input:focus,
  // .StripeElement--focus {
  //   box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
  //   -webkit-transition: all 150ms ease;
  //   transition: all 150ms ease;
  // }

  .StripeElement.IdealBankElement,
  .StripeElement.PaymentRequestButton {
    padding: 0;
  }

  .primaryColor {
    color: ${primaryColor} !important;
  }

  .primaryBackgroundColor {
    background-color: ${primaryColor} !important;
  }

  .primaryBorder {
    border: 1px solid ${primaryColor} !important;
  }

  .primaryBorder2px {
    border: 2px solid ${primaryColor} !important;
  }

  .primary{
  
  }

  .secondaryColor {
    color: ${secondaryColor} !important;
  }

  .secondaryBorder {
    border: 1px solid ${secondaryColor} !important;
  }

  .secondaryBorder2px {
    border: 2px solid ${secondaryColor} !important;
  }

  .secondaryBackgroundColor {
    background-color: ${secondaryColor} !important;
  }
  .primary {
    background-color: ${secondaryColor} !important;
  }
  .ui.menu {
    font-family: 'Inter';
  }

  .ui.selection.dropdown .menu {
  min-width: 350px;
  }
    .ui.message {
  border: none;
  box-shadow: none;
  outline: none;
  border-radius: ${DEUCE.PROPS.GLOBAL_BORDER_RADIUS};
  background: ${DEUCE.COLORS.SURFACE_LIGHTER};
}

.ui.message .header {
  font-family: 'Inter';
}

  .ui.primary.buttons .button:hover, .ui.primary.button:hover {
    background-color: rgb(23 123 198) !important;
  }

  .neonGreenColor {
    color: ${neonGreen} !important;
  }

  .neonGreenBackgroundColor {
    background-color: ${neonGreen} !important;
  }

  .actionButton {
    background-color: ${neonGreen} !important;
    color: #FFF !important;
  }

  .pusher{
    background: ${backgroundColor} !important;
  }
  .table{
    box-shadow: 0 1px 2px 0 rgba(34,36,38,.15) !important
    background: white !important
  }
  #todayNav{
    background: white;
    height: 5.5em;
  }
  #mapEmployees{
    box-shadow: rgba(34, 36, 38, 0.15) 0px 1px 2px 0px;
    z-index: 999;
    background:white !important;
    height: 6.5em;
    overflow-x: auto !important;
  }
  // #actionbar{
  //   background-color:#f9f9f9 !important
  // }

  // .deleteIcon:hover {
  //   color: #da0606 !important;
  // }

  // .editIcon:hover {
  //   color: #000000 !important;
  // }

  .actionIcon:hover {
    color: #000000 !important;
  }
  .leaflet-popup-content{
    margin:0px !important;
  }
  .leaflet-popup-content-wrapper {
    padding:0px !important;
  }

  .disabledInput {
    background-color: #f5f5f5 !important;
  }

  .toastr {
    box-shadow: none !important;
  }

  .docketToastr {
    z-index: 1000 !important;
  }

  .rrt-progressbar{
    background-color: #FFF !important;
  }

  .searchItem{
    background-color: #FFF !important;
    margin-right: 4px !important;
    width: 30em;
  }

  input {
    font-family: 'Inter' !important
  }

  .searchInput{
   background: rgb(220,220,220);
   border-radius: 20px;
    box-shadow: none !important;
  }

  .tableMenu{
    background-color: #f9f9f9 !important;
    padding-bottom: 2px !important;
  }

  .docketTable{
    width: 100% !important;
    margin: 1em 0em 0em 0em !important;
    padding-left: 1em !important;
    padding-right: 1em !important;
    box-shadow: none !important;
  }

  .terms{}
  .terms p {
    line-height: 1.75em;
  }
  .terms li{
    margin-bottom: 1.75rem;
  }

  .loaderText{
    font-weight: 500;
    padding-right: .1em !important;
    text-transform: uppercase;
  }

  .loaderSubText{
    text-transform: uppercase;
  }

  .ui.dimmer .ui.modal .ui.loader:before {
    border-color: rgba(0,0,0,.1);
  }
            
  .ui.dimmer .ui.modal .ui.loader:after {
    border-color: #767676 transparent transparent;
  }

  .mapEmployeeSelected{
    border:2px solid orange;
  }

  .mapEmployee{
      height: 1.5em !important;
      cursor:pointer;
      display: inline-block;
      opacity: 1;
      margin: 0 .25rem 0 0;
      width: 1.18em;
      height: 1em;
      font-family: Icons;
      font-style: normal;
      font-weight: 400;
      text-decoration: inherit;
      text-align: center;
      speak: none;
      font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      height: 1em;
      display: block;
      font-size: 1.71428571em!important;
      margin: 0 auto .5rem!important;
      margin: 0;
      opacity: 1;
      opacity: .9;
      float: none;
      margin: 0 .35714286em 0 0;
  }

  .mapBarContent{
      padding: 0em !important;
      display:flex !important;
      flex-direction: column;
      height: 100%;
      /* background-image: url("https://joshcompston.com/wp-content/themes/modern/images/header.jpg") */
  }

  .settingsCard {
    width: 400px !important;
    margin: 1em !important;
  }

  .settingsHeaderContainer {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #dededf;
    padding-bottom: 1em;
  }

  .settingsHeader{
    font-family: Inter;
    font-weight: 300;
    font-size: 24px;
    padding-bottom: .25em;
    padding-left: .5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: .5em 2em .5em 0em;
  }

  .settingsSubHeader{
    font-family: Inter;
    font-weight: 300;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: .5em 0em;
  }

  .settingsHeaderImage {
    padding-left: 1em;
    padding-right: 1em !important;
    height: 80px;
  }

  .settingListItem {
    padding: 1em 0em !important;
    margin-left: 2em;
  }

  .settingLabel {
    font-family: Inter;
    font-size: 1em; 
    font-weight: 500;
    margin-right: .5em;
    padding-bottom: 1em;
  }

  .settingDescriptionLabel {
    font-family: Inter;
    font-size: 1em; 
    font-weight: 300;
    margin-right: .5em;
    padding-bottom: 1em;
    margin-top: -.5em;
  }

  .settingValue {
    font-family: Inter; 
    font-size: 14px;
    font-weight: 300;
    margin-top: 1em;
  }

  .templateSettingLabel {
    font-family: Inter;
    font-size: 1em; 
    font-weight: 500;
    margin-right: .5em;
    padding-bottom: 1em;
  }

  .templateSettingValue {
    font-family: Inter; 
    font-size: 14px;
    font-weight: 300;
  }

  .reportSegment{
    cursor: pointer;
  }

  .reportSegmentInactive{
    background-color: #f1f1f1 !important;
  }

  .reportsHeaderContainer {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #dededf;
    padding-bottom: 1em;
  }

  .reportsHeader{
    font-family: Inter;
    font-weight: 300;
    font-size: 24px;
    padding-bottom: .25em;
    padding-left: .5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: .5em 0em;
  }

  .reportsHeaderImage {
    padding-left: 1em;
    padding-right: 1em !important;
    height: 80px;
  }

  .reportListItem {
    padding: .5em 0em !important;
  }

  .reportLabel {
    font-family: Inter;
    font-size: 1.25em; 
    font-weight: 500;
    margin-right: .5em;
    padding-bottom: .5em;
  }

  .reportValue {
    font-family: Inter; 
    font-size: 14px;
    font-weight: 300;
    margin-top: .25em;
  }

  .docketContentEditable{
    border-radius: 5px;
    font-weight: 300;
    border: 1px solid rgba(34, 36, 38, 0.15);
    padding: 0.67857143em 1em;
  }

  .docketContentEditable:focus {
    outline: #85B7D9 auto 0px !important;
  }

  .docketContentEditableTextArea{
    min-height: 6em !important;
    max-height: 6em !important;
    overflow-y: auto;
  }

  .docketContentEditableTextAreaLarge{
    min-height: 12em !important;
    max-height: 12em !important;
    overflow-y: auto;
  }

  .fc-toolbar.fc-header-toolbar {
    margin-bottom: .25em !important;
  }

  .fc-scroller .fc-day-grid-container {
    height: 800px !important;
  }

  .accordion {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }

  .accordion__item + .accordion__item {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .accordion__button {
      background-color: #56aaff;
      color: #FFF;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      text-align: left;
      border: none;
      font-family: Inter !important;
      font-weight: bold !important;
  }

  .accordion__button:hover {
      background-color: #55a7fb;
  }

  .accordion__button:before {
      display: inline-block;
      content: '';
      height: 10px;
      width: 10px;
      margin-right: 12px;
      border-bottom: 2px solid currentColor;
      border-right: 2px solid currentColor;
      transform: rotate(-45deg);
  }

  .accordion__button[aria-expanded='true']::before,
  .accordion__button[aria-selected='true']::before {
      transform: rotate(45deg);
  }

  .accordion__panel {
      padding: 20px;
      animation: fadein 0.35s ease-in;
  }

  /* -------------------------------------------------- */
  /* ---------------- Animation part ------------------ */
  /* -------------------------------------------------- */

  @keyframes fadein {
      0% {
          opacity: 0;
      }

      100% {
          opacity: 1;
      }
  }

  .fc-more-popover{
    max-height: 98%;
    overflow: auto;
  }

  .ui.page.modals.dimmer.transition.visible.active {
    display:flex !important;
    }  

    .smooth-dnd-container.horizontal{
      height:100%;
      pointer-events: none;
    }
    .react-trello-lane{
      pointer-events:auto;
    }
    .smooth-dnd-ghost{
      pointer-events: none;
    }
    .smooth-dnd-container.vertical{
      min-height: 12em;
    }
    // .smooth-dnd-stretcher-element.vertical{
    //   border: 2px dashed white;
    // }
  }

  .completedMapTask{
    transform: scale(0.5) translateY(100%) translateX(50%)
  }

  .fullHeightOverlay, .ui.top.sidebar, .ui.bottom.sidebar {
    width: 100% !important;
    height: 100% !important;
  }

  .pushable > .invertedPusher:after {
    position: fixed;
    top: 0px;
    right: 0px;
    content: '';
    background-color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    opacity: 0;
    -webkit-transition: opacity 500ms;
    transition: opacity 500ms;
    will-change: opacity;
    z-index: 1000;
}

body ::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 3px;  
  // -webkit-transition: color 0.2s ease;
  // transition: color 0.2s ease;
  // background-color: #96b3d6;
}
body ::-webkit-scrollbar-track {
  background:none;
  border-radius: 0px;
}

body ::-webkit-scrollbar {
  width: 6px !important;
}


*{
  transition: all .1s ease;
  transition: opacity .2s ease;
  transition: height .2s ease;
}

@-webkit-keyframes card-select-shadow {
  0% {
      box-shadow: none;
  }
  50% {
      box-shadow: 5px 5px 5px #4589fa;
  }
  100% {
      box-shadow: none;
  }
}

@keyframes card-select-shadow {
  0% {
      box-shadow: none;
  }
  50% {
      box-shadow: 5px 5px 5px #4589fa;
  }
  100% {
      box-shadow: none;
  }
}
.card-highlighter {
-webkit-animation:card-select-shadow ease-in-out 2s infinite; /* Chrome, Safari, Opera */
animation:card-select-shadow ease-in-out 2s infinite;
}

.ui.button, .ui.header {
  font-family: Inter;
}

.pp-price-block {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  flex-direction: column;
  }
  
  .pp-price-components > sup {
      font-size: 10px;
    }
  
    .price-block-shine-effect {
      height: calc(100% + 50px);
      width: 20px;
      position: absolute;
      background: linear-gradient(-90deg, rgba(255,255,255,0.5), transparent);
      left: -30px;
      top: -15px;
      z-index: 100;
      animation: shine-move 8.0s infinite;
      transform: rotate(-45deg);
    }
  
    @keyframes shine-move {
      0% {
        left: -40px;
        opacity: 0.0;
      }
  
      10% {
        opacity: 0.0;
        left: -40px;
      }
  
      11% {
        opacity: 1.0;
        left: -40px;
      }
  
      50% {
        left: calc(100% + 50px);
      }
  
      51% {
        left: -40px;
        opacity: 0.0;
      }
  
  
    }
    
    .pp-price-components {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      align-items: flex-start;
      /* background: linear-gradient(
    135deg
    , rgb(0,122,255), rgb(30,155,255)); */
      padding: 0px;
      position: relative;
      border-radius: 5px;
    }
  
    .pp-price-digits {
      display: flex;
      flex-direction: row;
      overflow: hidden;
      align-items: flex-start;
    }
  
    .pp-price-components.overlay {
      position: relative;
      color: inherit;
      white-space: nowrap;
      bottom: 0px;
      right: 0px;
      /* background: linear-gradient(135deg, rgb(0,122,255), rgb(30,155,255)); */
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 1.0;
      /* color: white; */
    }
    
    .pp-price-main {
      
    }
    
    .pp-price-header-text {
      text-transform: uppercase;
      font-size: 10px;
      line-height: 10px;
      opacity: 0.8;
    }
  
    .pp-price-main.emphasized {
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
    }

    .ui.items > .item > .content > .header {
      font-family: Inter;
    }

    .ui.items > .item > .content > .description {
      margin-top: 0px;
    }
    
.termsEditor > .ql-container {
  max-height: 500px;
  overflow-y: auto;
}

.ql-editor {
  min-height: 200px;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* SCHEDULER */
.schedulerContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.schedulerLegend {
  padding: 5px 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.schedulerLegendItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 26px;
  font-weight: 400;
  color: #444;
  flex-basis: 50%;
  justify-content: center;
}

.schedulerLegendColor {
  width: 25px;
  height: 15px;
  border-radius: 10px;
  margin-right: 10px;
}

.schedulerNav {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 15px;
  min-height: 50px;
}

.schedulerNavArrowButton {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  border-radius: 5px;
  padding: 5px;
}

.schedulerNavArrowButton.left {
  padding-right: 20px;
}

.schedulerNavArrowButton.right {
  padding-left: 20px;
}

.schedulerNavArrowButton:hover {
  color: black !important;
  cursor: pointer;
  background: rgba(0,0,0,0.1);
  border-radius: 5px;
}

.schedulerNavMonthLabel {
  font-weight: 700;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedulerMatrixContainer {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.schedulerMatrixHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #999;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.schedulerMatrixHeading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedulerMatrixRows {
  display: flex;
  flex-direction: column;
}

.schedulerMatrixRow {
  display: flex;
  flex-direction: row;
  font-size: 14px;
}

.schedulerMatrixCell {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  font-weight: 600;
  color: #222;
  animation-fill-mode: forwards;
  border-radius: 500px;
  pointer-events: none;
  transition: all 0.1s;
}

.schedulerMatrixCellHoverElem {
  width: 36px;
  height: 36px;
  pointer-events: none;
  border-radius: 46px;
  position: absolute;
  transition: transform 0.1s, opacity 0.1s;
  transform: translate3d(-50%, -50%, 0px) scale(1.0);
  background: rgb(230,230,230);
  z-index: -1;
  left: 50%;
  top: 50%;
}

.cellTodayElem {
  width: 46px;
  height: 46px;
  pointer-events: none;
  border-radius: 46px;
  position: absolute;
  transition: transform 0.1s, opacity 0.1s;
  transform: translate3d(-50%, -50%, 0px) scale(1.0);
  border: 1px solid rgb(200,200,200);
  z-index: -2;
  left: 50%;
  top: 50%;
}

.schedulerMatrixSelectionElem {
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: all;
  left: 0px;
  top: 0px;
  /* left: 50%;
  top: 50%; */
}

.schedulerMatrixSelectionElem:hover {
  cursor: pointer;
}

.offMonthCell {
  color: #999;
}

.cellSelected {
  color: white !important;
}

.cellDisabled {
  color: #CCC;
  pointer-events: none;
}

.cellSelectionElement {
  background: rgb(0,122,255);
  width: 32px;
  height: 32px;
  border-radius: 50px;
  position: absolute;
  z-index: -1;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0px);
}

.cellSelectionCancel {
  background: rgb(30,30,30);
  border-radius: 50px;
  padding: 5px 15px;
  position: absolute;
  left: 50%;
  height: 32px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  animation: cancelAnimation 0.2s forwards;
  top: 0px;
  pointer-events: all;
}

.cellSelectionCancel:hover {
  background: rgb(65,65,65);
  cursor: pointer;
}

@keyframes cancelAnimation {
  from {
      opacity: 0.0;
      transform: translate3d(-50%, 0px, 0px) scale(0.5)
  }

  to {
      opacity: 1.0;
      transform: translate3d(-50%, -50px, 0px) scale(1.0)
  }
}

.cellSelectionBridgeElement {
  width: 100%;
  height: 32px;
  position: absolute;
  background: rgb(0,122,255);
  z-index: -1;
  left: 0px;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
}

.cellSelectionEndCapElement {
  width: 50%;
  height: 32px;
  position: absolute;
  background: rgb(0,122,255);
  z-index: -1;
  left: 0px;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
  animation: selectionEndcapAnimation 0.1s forwards;
}

.cellSelectionStartCapElement {
  width: 50%;
  height: 32px;
  position: absolute;
  background: rgb(0,122,255);
  z-index: -1;
  left: 50%;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
}

.cellRangeEndcap {
  width: 50%;
  height: 36px;
  position: absolute;
  background: rgb(230,230,230);
  z-index: -3;
  left: 0px;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
}

.cellRangeBridge {
  width: 100%;
  height: 36px;
  position: absolute;
  background: rgb(230,230,230);
  z-index: -3;
  top: 50%;
  left: 0px;
  transform: translate3d(0px, -50%, 0px);
}

.cellRangeStartcap {
  width: 50%;
  height: 36px;
  position: absolute;
  background: rgb(230,230,230);
  z-index: -3;
  left: 50%;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
}

.scheduler-caret {
  width: 0;
  height: 0;
  display: inline-block;
  border: 10px solid transparent;
}
.scheduler-caret.down{
  border-top-color: #555;
}
.scheduler-caret.right{
  border-left-color: #555;
}
.scheduler-caret.up{
  border-bottom-color: #555;
}
.scheduler-caret.left{
  border-right-color: #555;
}

.cellDisabledElem {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 0;
  pointer-events: all;
  left: 0px;
  top: 0px;
  background-image: linear-gradient(0deg, rgba(0,0,0,0.1) 25%, transparent 25%, transparent 50%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.1) 75%, transparent 75%, transparent);
  background-size: 4px 4px;
}

.cellDisabledElem.unrendered {
  visibility: hidden;
}

@keyframes entrance-motion-left {
  from {
      opacity: 0.1;
      transform: translate3d(-5px, 0px, 0px);
  }

  to {
      opacity: 1.0;
      transform: translate3d(0px, 0px, 0px);
  }
}

@keyframes entrance-motion-right {
  from {
      opacity: 0.1;
      transform: translate3d(5px, 0px, 0px);
  }

  to {
      opacity: 1.0;
      transform: translate3d(0px, 0px, 0px);
  }
}

@keyframes selectionEndcapAnimation {
  from {
      width: 0px
  }

  to {
      width: 50%;
  }
}

/* END SCHEDULER */

.raised_area {
  padding: 10px;
  border-radius: 5px;
  background: linear-gradient(180deg, #F6F6F6, #F6F6F6);
  z-index: 1;
  box-shadow: 0px 2px 7px rgba(0,0,0,0.1), 0px 0px 0px 1px rgba(0,0,0,0.2) inset,  0px 1px 0px 1px rgba(255,255,255) inset;
}

.nested_raised_area {
  padding: 10px;
  border-radius: 5px;
  background: #FAFAFA;
  z-index: 1;
  box-shadow: 0px 2px 5px rgba(0,0,0,0.05), 0px 0px 0px 1px rgba(0,0,0,0.1) inset,  0px 1px 0px 1px rgba(255,255,255) inset;
}

.dragged-ui-element {
  transform-origin: top left;
  pointer-events: none;
}

.dragged-ui-element-transform {
  animation: dragged_element_entrance 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  box-shadow: 0px 3px 15px rgba(0,0,0,0.2);
}

.dragged-ui-element-transform.no-target-exit {
  animation: no_target_exit 0.25s forwards;
}

.dragged-ui-element-transform.target-exit {
  animation: target_exit 0.25s forwards;
}

@keyframes no_target_exit {
  from {
    opacity: 1.0;
    transform: scale3d(1.0, 1.0, 1.0);
  }

  to {
    opacity: 0.0;
    transform: scale3d(1.2, 1.2, 1.0);
  }
}

@keyframes target_exit {
  from {
    opacity: 1.0;
    transform: scale3d(1.0, 1.0, 1.0);
  }

  to {
    opacity: 0.0;
    transform: scale3d(0.8, 0.8, 1.0);
  }
}

@keyframes dragged_element_entrance {
  from {
    opacity: 0.0;
    transform: scale3d(0.3, 0.3, 1.0);
  }

  to {
    opacity: 1.0;
    transform: scale3d(1.0, 1.0, 1.0);
  }
}

.react-datetime-picker__wrapper {
  border: none !important;
  border-radius: 5px;
  background: rgba(0,0,0,0.075);
  font-family: Inter !important;
  font-weight: 700;
  padding: 3px 15px;
}

/**
 * Semantic Dropdown -> DEUCE
 *
 */
.ui.selection.dropdown {
  min-width: 100px !important;
  border-radius: ${DEUCE.PROPS.TEXT_FIELD_BORDER_RADIUS};
  font-size: ${DEUCE.PROPS.GLOBAL_FONT_SIZE};
  line-height: 1;
  position: relative;
  min-height: 36px;
  border: 1px solid transparent !important;
  min-width: 100px;
  box-shadow: 0px 0px 0px 1px ${DEUCE.COLORS.TEXT_FIELD_BORDER_ENABLED} inset;
  color: ${DEUCE.COLORS.TEXT_MAIN_HIGH_EMPHASIS};
  background: ${DEUCE.COLORS.SURFACE_PURE_WHITE};
  text-align: left;
  white-space: nowrap;
}



.ui.active.selection.dropdown {
  background: ${DEUCE.COLORS.SURFACE_PURE_WHITE};
  border-radius: ${DEUCE.PROPS.GLOBAL_BORDER_RADIUS} !important;
}

.ui.selection.dropdown:hover {
  background: ${DEUCE.COLORS.SURFACE_PURE_WHITE};
  box-shadow: 0px 0px 0px 1px ${DEUCE.COLORS.TEXT_FIELD_BORDER_HOVER} inset;
}

.ui.selection.dropdown:focus {
  background: ${DEUCE.COLORS.SURFACE_PURE_WHITE};
  box-shadow: 0px 0px 0px 1px ${DEUCE.COLORS.TEXT_FIELD_BORDER_HOVER} inset;
}

.ui.selection.active.dropdown, .ui.selection.active.dropdown:hover {
  box-shadow: 0px 0px 0px ${DEUCE.PROPS.TEXT_FIELD_BORDER_WIDTH_ACTIVATED} ${
  DEUCE.COLORS.TEXT_FIELD_BORDER_ACTIVATED
} inset;
}

.ui.selection.dropdown>.delete.icon, .ui.selection.dropdown>.dropdown.icon, .ui.selection.dropdown>.search.icon {
  color: ${DEUCE.COLORS.TEXT_MAIN_HIGH_EMPHASIS};
}


.ui.toggle.checkbox label:before {
  width: 44px;
  height: 24px;
  background-color: var(--toggle-off);
}

.ui.toggle.checkbox label:hover:before {
  background-color: var(--toggle-off-hover);
}

.ui.toggle.checkbox input:checked ~ label:before {
  background-color: var(--toggle-on) !important;
}

.ui.toggle.checkbox input:checked ~ label:hover:before {
  background-color: var(--toggle-on-hover) !important;
}

.ui.toggle.checkbox label:after {
  background: var(--surface-pure-white);
  left: 2px !important;
  top: 2px !important;
  width: 20px !important;
  height: 20px !important;
  box-shadow: 0px 1px 2px 0px #1018280d, 0px 1px 2px 0px #1018280f;
  transition: background 0.3s cubic-bezier(0.04, 0.8, 0.25, 1),
    left 0.3s cubic-bezier(0.15, 0.99, 0.25, 1);
}

.ui.toggle.checkbox input:checked ~ label:after {
  left: 22px !important;
  box-shadow: 0px 1px 2px 0px #1018280d, 0px 1px 2px 0px #1018280f;
}

.ui.attached.warning.message,
.ui.warning.message {
  box-shadow: none;
  padding: 20px;
  background: var(--surface-warning-light);
}

.ui.warning.message .header,
.ui.warning.message {
  color: var(--text-main-high-emphasis);
}

.ui.warning.message .close.icon {
  margin-right: 10px;
  font-size: 16px;
}

@container (inline-size < 100px) {
  .activeMenuItem > div,
  .inactiveMenuItem > div {
    font-size: 11px !important;
    line-height: 1.3 !important;
    overflow-wrap: break-word !important;
    word-break: keep-all !important;
  }
}

`;
